<div class="filter-groups-root">
  @if (containerGroup && topLevelGroups.length > 1) {
    <div class="container-operator-row">
      <span class="container-operator-label">Combine groups with</span>
      <div class="group-operator-toggle">
        <button
          type="button"
          class="operator-btn"
          [class.operator-btn--active]="containerGroup.operator === 'AND'"
          (click)="onToggleOperator('AND')">
          AND
        </button>
        <button
          type="button"
          class="operator-btn"
          [class.operator-btn--active]="containerGroup.operator === 'OR'"
          (click)="onToggleOperator('OR')">
          OR
        </button>
      </div>
    </div>
  }

  @if (topLevelGroups.length > 0) {
    <div class="top-level-groups">
      @for (group of topLevelGroups; track group.id; let i = $index) {
        @if (i > 0) {
          <div class="group-connector">
            <span class="connector-line"></span>
            <span class="connector-operator-label">{{ containerGroup.operator }}</span>
            <span class="connector-line"></span>
          </div>
        }

        <app-shared-modal-filters-advanced-group
          [allowDeleteTopLevel]="canDeleteTopLevelGroup"
          [depth]="0"
          [isTopLevelGroup]="true"
          [predecessorID]="group.id"
          [setColDef]="colDefs"
          [setFilterGroups]="group">
        </app-shared-modal-filters-advanced-group>
      }
    </div>
  }

  <div class="add-top-level-group">
    <button type="button" class="af-text-btn" (click)="onAddTopLevelGroupClick()">
      <app-icon-playlist-plus [tooltip]="'Add Group'"></app-icon-playlist-plus>
      Add Group
    </button>
  </div>
</div>
